import { createFileRoute } from '@tanstack/react-router';
import FuelLevelLitersOnline from '../../../components/Graphs/FuelLevelLiters';

export const Route = createFileRoute('/_authenticated/graphs/fuel-level-liters/$vehicleId')({
  beforeLoad: ({ context }) => {
    // requirePermission(PERMISSION_RIDES, ['read']);
    return {
      ...context,
      documentTitle: {
        main: 'widget.fuelLevel.tooltip',
        params: { valueType: 'L' },
      },
      isMenuDisabled: true,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: FuelLevelLitersGraphRoute,
});

function FuelLevelLitersGraphRoute() {
  const { vehicleId } = Route.useParams();

  return <FuelLevelLitersOnline vehicleId={Number(vehicleId)} isPage />;
}
